<div class="draggable-container" cdkDrag cdkDragBoundary=".modal" cdkDragRootElement="draggable-container">
  <div class="draggable-modal-content " >
<ng-container>
    <form #paymentForm = "ngForm" [formGroup]="takePaymentForm" novalidate>
        <div class="modal-header align-items-center cursor-pointer" cdkDragHandle>
          <h6 *ngIf="loanTransactionDetails?.payment_info_code?.slug!='WAIVE'" class="modal-title modal-title-success">{{editMode ? ('Edit' | translate) : ''}} {{'Take Payment'|translate}}</h6>
          <h6 *ngIf="loanTransactionDetails?.payment_info_code?.slug=='WAIVE'" class="modal-title modal-title-success">{{'Edit Fee Balances'|translate}}</h6>
          <button type="button" class="btn-close" aria-label="'Close' | translate" (click)="activeModal.dismiss('Cross click')">
          </button>
        </div>
        <div class="modal-body p-0">
          <div class="lms-module-card">
            <div class="card-body">
              <div class="card-form-content card-form-success">
                <div class="row mb-3">
                  <div class="col-lg-7">
                    <div *ngIf="loanTransactionDetails?.payment_info_code?.code_type!='NON-CASH-SYSTEM'" class="row gutters-5">
                      <div class="field-group mb-3 col-lg-5">
                        <label class="form-group-label field-required">{{'Payment Code'|translate}}</label>
                      </div>
                      <div class="field-group mb-3 col-lg-7">
                        <select name="payment_info_code_id"
                        formControlName="payment_info_code_id" class="form-control form-control-sm"
                        (change)="customValidators(true)">
                          <option [ngValue]="null">{{'-Select-'|translate}}</option>
                          <option *ngFor="let item of paymentCodeList"   [ngValue]="item.id">
                            {{item.code}}
                          </option>
                        </select>
                      </div>
                      <val-errors controlName="payment_info_code_id">
                        <ng-template valError="required">{{'Please select payment code'|translate}}.</ng-template>
                      </val-errors>
                    </div>
                    <div class="row gutters-5">
                      <div class="field-group mb-3 col-lg-5">
                        <label class="form-group-label field-required">{{'Effective Date'|translate}}</label>
                      </div>
                      <div class="field-group mb-3 col-lg-7">
                        <ng-container *ngIf="loanTransactionDetails?.payment_info_code?.slug=='WAIVE'">
                          <input type="text"
                          [readOnly]="loanTransactionDetails?.payment_info_code?.slug=='WAIVE'"
                          formControlName="payment_effective_date"
                          name="payment_effective_date"
                          class="form-control form-control-sm" [value]=""
                          />
                        </ng-container>
                        <ng-container *ngIf="loanTransactionDetails?.payment_info_code?.slug!='WAIVE'">
                          <app-date-picker name="payment_effective_date"
                          formControlName="payment_effective_date"></app-date-picker>
                        </ng-container>
                      </div>
                      <val-errors controlName="payment_effective_date">
                        <ng-template valError="required">{{'Please enter a date'|translate}}.</ng-template>
                      </val-errors>
                    </div>
                    <div *ngIf="selectedPaymentCode?.code_type=='CASH'" class="row gutters-5">
                      <div class="field-group mb-3 col-lg-5">
                        <label class="form-group-label field-required">{{'Payment Method'|translate}}</label>
                      </div>
                      <div class="field-group mb-3 col-lg-7">
                        <select name="payment_method_id" formControlName="payment_method_id" class="form-control form-control-sm">
                          <option [ngValue]="null">{{'-Select-'|translate}}</option>
                          <option *ngFor="let item of paymentMethodList" [ngValue]="item.id">
                            {{item.source}}
                          </option>
                        </select>
                      </div>
                      <val-errors controlName="payment_method_id">
                        <ng-template valError="required">{{'Please select payment method'|translate}}.</ng-template>
                      </val-errors>
                    </div>
                    <div class="row gutters-5">
                      <div class="field-group mb-3 col-lg-5">
                        <label class="form-group-label field-required">{{'Amount'|translate}}</label>
                      </div>
                      <div class="field-group mb-3 col-lg-7">
                        <div class="currency-wrap">
                          <span class="currency-code">$</span>
                          <input type="text" (input)="onPaymentAmountInput($event)" (blur)="checkMainAmount($event)"
                          formControlName="payment_amount"
                          name="payment_amount" placeholder="{{'Please enter amount'|translate}}"
                          class="form-control form-control-sm" [value]=""
                          onfocus="select()"
                          mask="separator.2" thousandSeparator="," [allowNegativeNumbers]="true"
                          />
                        </div>
                      </div>
                      <val-errors controlName="payment_amount">
                        <ng-template valError="required">{{'Please enter amount'|translate}}.</ng-template>
                        <ng-template valError="invalidBreakdownNegative" *ngIf="!takePaymentForm?.controls?.payment_amount?.errors?.required">
                          <span *ngIf="this.isManualBreakdownAllowed() && !isManualTakePayment && loanTransactionDetails?.payment_info_code?.code_type!='NON-CASH-SYSTEM';else defaultMsg">
                            {{'Negative (-ve) payments are not allowed in the default breakdown. To post a negative payment, please use the manual breakdown option'|translate}}.
                          </span>
                          <ng-template #defaultMsg>
                            <span *ngIf="takePaymentForm.value.payment_info_code_id">
                              {{'Negative (-ve) payments are not allowed for selected payment code'|translate}}.
                            </span>
                          </ng-template>
                        </ng-template>
                        <ng-template valError="currencyRange" *ngIf="!takePaymentForm?.controls?.payment_amount?.errors?.required && !takePaymentForm?.controls?.payment_amount?.errors?.invalidBreakdownNegative && !isIncompleteNegativePaymentAmount">{{'Amount must be between' | translate}} -{{paymentAmountLimit | currency}} {{'and' | translate }} {{paymentAmountLimit | currency}}.</ng-template>
                        <ng-template valError="zeroNotAllowed" *ngIf="!takePaymentForm?.controls?.payment_amount?.errors?.required && !takePaymentForm?.controls?.payment_amount?.errors?.invalidBreakdownNegative && !takePaymentForm?.controls?.payment_amount?.errors?.currencyRange">{{'Amount cannot be zero' | translate}}.</ng-template>
                    </val-errors>
                    </div>
                    <!-- <div class="row gutters-5"  *ngIf="this.loanDetail?.status!='CHARGED-OFF'"> -->
                      <div class="row gutters-5" *ngIf="loanTransactionDetails?.payment_info_code?.slug!='WAIVE'">
                      <div class="field-group mb-3 col-lg-5">
                        <label class="form-group-label field-required">{{'Posting Method'|translate}}</label>
                      </div>
                      <div class="field-group mb-3 col-lg-7">
                        <select name="posting_method" formControlName="posting_method" class="form-control form-control-sm">
                          <option [ngValue]="null">{{'-Select-'|translate}}</option>
                          <option value="ROLL_DUE_DATE">{{'Rolls Due Date'|translate}} </option>
                          <option value="ROLL_UNTIL_CURRENT">{{'Rolls Until Current'|translate}} </option>
                          <option value="DO_NOT_ROLL_DUE_DATE">{{"Doesn't Roll Due Date"|translate}} </option>
                          <!-- <option value="Payment Doesn't Roll Due Date">Payment Doesn't Roll Due Date</option> -->
                        </select>
                      </div>
                      <val-errors controlName="posting_method">
                        <ng-template valError="required">{{'Please select posting method'|translate}}.</ng-template>
                    </val-errors>
                    </div>
                    <!------------------------Pmt Received Method -------------------------------->
                    <div class="row gutters-5" *ngIf="loanTransactionDetails?.payment_info_code?.slug!='WAIVE'">
                      <div class="field-group mb-3 col-lg-5">
                        <label class="form-group-label">{{'Pmt Received Method'|translate}} </label>
                      </div>
                      <div class="field-group mb-3 col-lg-7">
                        <select name="payment_received_method" formControlName="payment_received_method" class="form-control form-control-sm">
                          <option [ngValue]="null">{{'-Select-'|translate}}</option>
                          <option value="RECEIVED_IN_MAIL">{{'Received In Mail'|translate}} </option>
                          <option value="MADE_IN_PERSON">{{'Made In Person'|translate}} </option>
                          <option value="OTHER">{{'Other'|translate}} </option>

                          <!-- <option value="Payment Doesn't Roll Due Date">Payment Doesn't Roll Due Date</option> -->
                        </select>
                      </div>
                    </div>
                    <!------------------------Pmt Received Method End-------------------------------->
                  </div>
                </div>
                <div class="maunal-waterfall-breakdown" *ngIf="isManualTakePayment && this.isManualBreakdownAllowed()">
                  <!-- <div class="maunal-waterfall-breakdown" *ngIf="isManualTakePayment"> -->
                  <div class="maunal-waterfall-breakdown-grid maunal-payment-breakdown-grid-header maunal-waterfall-breakdown-header">
                    <div class="maunal-waterfall-breakdown-item font-weight-bold">
                      {{'Input Breakdown'|translate}}
                    </div>
                    <div class="maunal-waterfall-breakdown-item font-weight-bold" [ngClass]="{'visibility-hidden' : isEffectiveDateChangedInEditMode}">
                      {{'Balance Before'|translate}}
                    </div>
                    <div class="maunal-waterfall-breakdown-item"></div>
                    <div class="maunal-waterfall-breakdown-item font-weight-bold" [ngClass]="{'visibility-hidden' : isEffectiveDateChangedInEditMode}">
                      {{'Balance After'|translate}}
                    </div>
                  </div>
                  <div class="maunal-waterfall-breakdown-body">
                    <!-- Item 1 -->
                    <div  *ngIf="loanTransactionDetails?.payment_info_code?.slug!='WAIVE'" class="maunal-waterfall-breakdown-grid maunal-waterfall-breakdown-grid-2 align-items-center">
                      <div class="maunal-waterfall-breakdown-item">
                        <div class="row gutters-5">
                          <div class="field-group mb-3 col-lg-5">
                            <label class="form-group-label">{{'Principal'|translate}}</label>
                          </div>
                          <div class="field-group mb-3 col-lg-7">
                            <div class="currency-wrap">
                              <span class="currency-code">$</span>
                              <input [readonly]="loanTransactionDetails?.payment_info_code?.slug=='WAIVE'" type="text" name="principal_payment" formControlName="principal_payment"
                              (input)="onManualBreakdownInput('principal_payment', $event)" (blur)="calculateBalance($event)" class="form-control form-control-sm"
                              placeholder="0.00" [value]=""
                              onfocus="select()" 
                              mask="separator.2" thousandSeparator="," [allowNegativeNumbers]="true"/>
                            </div>
                          </div>
                        </div>
                      </div>
                        <div class="maunal-waterfall-breakdown-item" [ngClass]="{'visibility-hidden' : isEffectiveDateChangedInEditMode}">
                            <div class="row gutters-5">
                                <div class="field-group mb-3 col-lg-4">
                                    <label class="form-group-label">
                                      {{(balanceBeforeTransaction?.remaining_principal_balance || '0.00' ) | currency}}
                                    </label>
                                </div>
                                <div class="field-group mb-3 col-lg-2 text-center">
                                    <label class="form-group-label">
                                      <img class="img-fluid icon-dark" src="assets/images/icons/arrow2.png" alt="" />
                                      <img class="img-fluid icon-light" src="assets/images/icons/arrow2-light.png" />
                                    </label>
                                </div>
                                <div class="field-group mb-3 col-lg-5">
                                    <label class="form-group-label balance-after">
                                      {{(balanceAfter?.principal_payment  ) | currency}}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <val-errors controlName="principal_payment">
                          <ng-template valError="required">{{'Required field'|translate}}.</ng-template>
                          <ng-template valError="invalidPaymentSign" let-error="error" *ngIf="!takePaymentForm?.controls?.principal_payment?.errors?.required">{{error?.message|translate}}.</ng-template>
                          <ng-template valError="currencyRange" *ngIf="!takePaymentForm?.controls?.principal_payment?.errors?.required && !takePaymentForm?.controls?.principal_payment?.errors?.invalidPaymentSign && !isIncompleteNegativeBreakdownInput('principal_payment')">{{'Principal Payment must be between'|translate}} {{manualBreakdownRangeMin | currency}} {{'and'|translate}} {{manualBreakdownRangeMax | currency}}.</ng-template>
                          <ng-template valError="invalidBalanceAfterRange" let-error="error" *ngIf="!takePaymentForm?.controls?.principal_payment?.errors?.required && !takePaymentForm?.controls?.principal_payment?.errors?.invalidPaymentSign && !takePaymentForm?.controls?.principal_payment?.errors?.currencyRange  && !isLoadingEffectiveDateBalances">{{error?.message|translate}}.</ng-template>
                        </val-errors>
                    </div>
                    <!-- Item 2 -->
                    <div  *ngIf="loanTransactionDetails?.payment_info_code?.slug!='WAIVE'" class="maunal-waterfall-breakdown-grid maunal-waterfall-breakdown-grid-2 align-items-center">
                      <div class="maunal-waterfall-breakdown-item">
                        <div class="row gutters-5">
                          <div class="field-group mb-3 col-lg-5">
                            <label class="form-group-label">{{'Interest'|translate}} </label>
                          </div>
                          <div class="field-group mb-3 col-lg-7">
                            <div class="currency-wrap">
                              <span class="currency-code">$</span>
                              <input [readonly]="loanTransactionDetails?.payment_info_code?.slug=='WAIVE'" type="text" name="interest_payment" formControlName="interest_payment"
                              (input)="onManualBreakdownInput('interest_payment', $event)" (blur)="calculateBalance($event)" class="form-control form-control-sm"
                              placeholder="0.00" [value]=""
                              onfocus="select()" 
                              mask="separator.2" thousandSeparator="," [allowNegativeNumbers]="true" />
                            </div>
                          </div>
                        </div>
                      </div>
                        <div class="maunal-waterfall-breakdown-item" [ngClass]="{'visibility-hidden' : isEffectiveDateChangedInEditMode}">
                            <div class="row gutters-5">
                                <div class="field-group mb-3 col-lg-4">
                                    <label class="form-group-label">
                                      {{(balanceBeforeTransaction?.remaining_interest_balance || '0.00' ) | currency}}
                                    </label>
                                </div>
                                <div class="field-group mb-3 col-lg-2 text-center">
                                    <label class="form-group-label">
                                      <img class="img-fluid icon-dark" src="assets/images/icons/arrow2.png" alt="" />
                                      <img class="img-fluid icon-light" src="assets/images/icons/arrow2-light.png" />
                                    </label>
                                </div>
                                <div class="field-group mb-3 col-lg-5">
                                    <label class="form-group-label balance-after">
                                      {{(balanceAfter?.interest_payment  ) | currency}}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <val-errors controlName="interest_payment">
                          <ng-template valError="required">{{'Required field'|translate}}.</ng-template>
                          <ng-template valError="invalidPaymentSign" let-error="error" *ngIf="!takePaymentForm?.controls?.interest_payment?.errors?.required">{{error?.message|translate}}.</ng-template>
                          <ng-template valError="currencyRange" *ngIf="!takePaymentForm?.controls?.interest_payment?.errors?.required && !takePaymentForm?.controls?.interest_payment?.errors?.invalidPaymentSign && !isIncompleteNegativeBreakdownInput('interest_payment')">{{'Interest Payment Fees must be between'|translate}} {{manualBreakdownRangeMin | currency}} {{'and'|translate}} {{manualBreakdownRangeMax | currency}}.</ng-template>
                          <ng-template valError="invalidBalanceAfterRange"  let-error="error" *ngIf="!takePaymentForm?.controls?.interest_payment?.errors?.required && !takePaymentForm?.controls?.interest_payment?.errors?.invalidPaymentSign && !takePaymentForm?.controls?.interest_payment?.errors?.currencyRange  && !isLoadingEffectiveDateBalances">{{error?.message|translate}}.</ng-template>
                        </val-errors>
                    </div>
                    <!-- Item 3 -->
                    <div class="maunal-waterfall-breakdown-grid maunal-waterfall-breakdown-grid-2 align-items-center">
                      <div class="maunal-waterfall-breakdown-item">
                        <div class="row gutters-5">
                          <div class="field-group mb-3 col-lg-5">
                            <label class="form-group-label">{{'Late Fees'|translate}}</label>
                          </div>
                          <div class="field-group mb-3 col-lg-7">
                            <div class="currency-wrap">
                              <span class="currency-code">$</span>
                              <input type="text" name="late_fees_payment" formControlName="late_fees_payment"
                              (input)="onManualBreakdownInput('late_fees_payment', $event)" (blur)="calculateBalance($event)" class="form-control form-control-sm"
                              placeholder="0.00"  [value]=""
                              onfocus="select()" 
                              mask="separator.2" thousandSeparator="," [allowNegativeNumbers]="true" />
                            </div>
                          </div>
                        </div>
                      </div>
                        <div class="maunal-waterfall-breakdown-item" [ngClass]="{'visibility-hidden' : isEffectiveDateChangedInEditMode}">
                            <div class="row gutters-5">
                                <div class="field-group mb-3 col-lg-4">
                                    <label class="form-group-label">
                                      {{(balanceBeforeTransaction?.remaining_late_fees_balance || '0.00' ) | currency}}
                                    </label>
                                </div>
                                <div class="field-group mb-3 col-lg-2 text-center">
                                    <label class="form-group-label">
                                      <img class="img-fluid icon-dark" src="assets/images/icons/arrow2.png" alt="" />
                                      <img class="img-fluid icon-light" src="assets/images/icons/arrow2-light.png" />
                                    </label>
                                </div>
                                <div class="field-group mb-3 col-lg-5">
                                    <label class="form-group-label balance-after">
                                      {{(balanceAfter?.late_fees_payment )  | currency  }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <val-errors controlName="late_fees_payment">
                          <ng-template valError="required">{{'Required field'|translate}}.</ng-template>
                          <ng-template valError="invalidPaymentSign" let-error="error" *ngIf="!takePaymentForm?.controls?.late_fees_payment?.errors?.required">{{error?.message|translate}}.</ng-template>
                          <ng-template valError="currencyRange" *ngIf="!takePaymentForm?.controls?.late_fees_payment?.errors?.required && !takePaymentForm?.controls?.late_fees_payment?.errors?.invalidPaymentSign && !isIncompleteNegativeBreakdownInput('late_fees_payment')">{{'Late Fees must be between'|translate}} {{manualBreakdownRangeMin | currency}} {{'and'|translate}} {{manualBreakdownRangeMax | currency}}.</ng-template>
                          <ng-template valError="invalidBalanceAfterRange"  let-error="error" *ngIf="!takePaymentForm?.controls?.late_fees_payment?.errors?.required && !takePaymentForm?.controls?.late_fees_payment?.errors?.invalidPaymentSign && !takePaymentForm?.controls?.late_fees_payment?.errors?.currencyRange  && !isLoadingEffectiveDateBalances">{{error?.message|translate}}.</ng-template>
                        </val-errors>
                    </div>
                    <!-- Item 4 -->
                    <div class="maunal-waterfall-breakdown-grid maunal-waterfall-breakdown-grid-2 align-items-center">
                      <div class="maunal-waterfall-breakdown-item">
                        <div class="row gutters-5">
                          <div class="field-group mb-3 col-lg-5">
                            <label class="form-group-label">{{'NSF Fees'|translate}}</label>
                          </div>
                          <div class="field-group mb-3 col-lg-7">
                            <div class="currency-wrap">
                              <span class="currency-code">$</span>
                              <input type="text" name="nsf_fees_payment" formControlName="nsf_fees_payment"
                              (input)="onManualBreakdownInput('nsf_fees_payment', $event)" (blur)="calculateBalance($event)" class="form-control form-control-sm"
                              placeholder="0.00"[value]=""
                              onfocus="select()" 
                              mask="separator.2" thousandSeparator="," [allowNegativeNumbers]="true" />
                            </div>
                          </div>
                        </div>
                      </div>
                        <div class="maunal-waterfall-breakdown-item" [ngClass]="{'visibility-hidden' : isEffectiveDateChangedInEditMode}">
                            <div class="row gutters-5">
                                <div class="field-group mb-3 col-lg-4">
                                    <label class="form-group-label">
                                      {{(balanceBeforeTransaction?.remaining_nsf_fees_balance|| '0.00' ) | currency}}
                                    </label>
                                </div>
                                <div class="field-group mb-3 col-lg-2 text-center">
                                    <label class="form-group-label">
                                      <img class="img-fluid icon-dark" src="assets/images/icons/arrow2.png" alt="" />
                                      <img class="img-fluid icon-light" src="assets/images/icons/arrow2-light.png" />
                                    </label>
                                </div>
                                <div class="field-group mb-3 col-lg-5">
                                    <label class="form-group-label balance-after">
                                      {{(balanceAfter?.nsf_fees_payment ) | currency}}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <val-errors controlName="nsf_fees_payment">
                          <ng-template valError="required">{{'Required field'|translate}}.</ng-template>
                          <ng-template valError="invalidPaymentSign" let-error="error" *ngIf="!takePaymentForm?.controls?.nsf_fees_payment?.errors?.required">{{error?.message|translate}}.</ng-template>
                          <ng-template valError="currencyRange" *ngIf="!takePaymentForm?.controls?.nsf_fees_payment?.errors?.required && !takePaymentForm?.controls?.nsf_fees_payment?.errors?.invalidPaymentSign && !isIncompleteNegativeBreakdownInput('nsf_fees_payment')">{{'NSF Fees must be between'|translate}} {{manualBreakdownRangeMin | currency}} {{'and'|translate}} {{manualBreakdownRangeMax | currency}}.</ng-template>
                          <ng-template valError="invalidBalanceAfterRange"  let-error="error" *ngIf="!takePaymentForm?.controls?.nsf_fees_payment?.errors?.required && !takePaymentForm?.controls?.nsf_fees_payment?.errors?.invalidPaymentSign && !takePaymentForm?.controls?.nsf_fees_payment?.errors?.currencyRange  && !isLoadingEffectiveDateBalances">{{error?.message|translate}}.</ng-template>
                        </val-errors>
                    </div>
                    <!-- Item 5 -->
                    <div class="maunal-waterfall-breakdown-grid maunal-waterfall-breakdown-grid-2 align-items-center">
                      <div class="maunal-waterfall-breakdown-item">
                        <div class="row gutters-5">
                          <div class="field-group mb-3 col-lg-5">
                            <label class="form-group-label">{{'Other Fees'|translate}}</label>
                          </div>
                          <div class="field-group mb-3 col-lg-7">
                            <div class="currency-wrap">
                              <span class="currency-code">$</span>
                              <input type="text" name="other_fees_payment" formControlName="other_fees_payment"
                                (input)="onManualBreakdownInput('other_fees_payment', $event)" (blur)="calculateBalance($event)"
                                class="form-control form-control-sm" placeholder="0.00" [value]=""
                                onfocus="select()"
                                mask="separator.2" thousandSeparator="," [allowNegativeNumbers]="true"  />
                            </div>
                          </div>
                        </div>
                      </div>
                        <div class="maunal-waterfall-breakdown-item" [ngClass]="{'visibility-hidden' : isEffectiveDateChangedInEditMode}">
                            <div class="row gutters-5">
                                <div class="field-group mb-3 col-lg-4">
                                    <label class="form-group-label">
                                      {{(balanceBeforeTransaction?.remaining_other_fees_balance|| '0.00' ) | currency}}
                                    </label>
                                </div>
                                <div class="field-group mb-3 col-lg-2 text-center">
                                    <label class="form-group-label">
                                      <img class="img-fluid icon-dark" src="assets/images/icons/arrow2.png" alt="" />
                                      <img class="img-fluid icon-light" src="assets/images/icons/arrow2-light.png" />
                                    </label>
                                </div>
                                <div class="field-group mb-3 col-lg-5">
                                    <label class="form-group-label balance-after">
                                      {{(balanceAfter?.other_fees_payment ) | currency}}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <val-errors controlName="other_fees_payment">
                          <ng-template valError="required">{{'Required field'|translate}}.</ng-template>
                          <ng-template valError="invalidPaymentSign" let-error="error" *ngIf="!takePaymentForm?.controls?.other_fees_payment?.errors?.required">{{error?.message|translate}}.</ng-template>
                          <ng-template valError="currencyRange" *ngIf="!takePaymentForm?.controls?.other_fees_payment?.errors?.required && !takePaymentForm?.controls?.other_fees_payment?.errors?.invalidPaymentSign && !isIncompleteNegativeBreakdownInput('other_fees_payment')">{{'Other Fees must be between'|translate}} {{manualBreakdownRangeMin | currency}} {{'and'|translate}} {{manualBreakdownRangeMax | currency}}.</ng-template>
                          <ng-template valError="invalidBalanceAfterRange"  let-error="error" *ngIf="!takePaymentForm?.controls?.other_fees_payment?.errors?.required && !takePaymentForm?.controls?.other_fees_payment?.errors?.invalidPaymentSign && !takePaymentForm?.controls?.other_fees_payment?.errors?.currencyRange  && !isLoadingEffectiveDateBalances">{{error?.message|translate}}.</ng-template>
                        </val-errors>
                    </div>
                    <!-- sales tax Item  -->
                    <div class="maunal-waterfall-breakdown-grid maunal-waterfall-breakdown-grid-2 align-items-center" *ngIf="clientDetailService?.industry_type?.code === 'BUY_HERE_PAY_HERE'">
                      <div class="maunal-waterfall-breakdown-item">
                        <div class="row gutters-5">
                          <div class="field-group mb-3 col-lg-5">
                            <label class="form-group-label">{{'Sales Tax'|translate}}</label>
                          </div>
                          <div class="field-group mb-3 col-lg-7">
                            <div class="currency-wrap">
                              <span class="currency-code">$</span>
                              <input type="text" name="tax_payment" formControlName="tax_payment"
                                  (input)="onManualBreakdownInput('tax_payment', $event)" (blur)="calculateBalance($event)"
                                  class="form-control form-control-sm" placeholder="0.00" [value]=""
                                  onfocus="select()"
                                  mask="separator.2" thousandSeparator="," [allowNegativeNumbers]="true"
                                  />
                            </div>
                          </div>
                        </div>
                      </div>
                        <div class="maunal-waterfall-breakdown-item" [ngClass]="{'visibility-hidden' : isEffectiveDateChangedInEditMode}">
                            <div class="row gutters-5">
                                <div class="field-group mb-3 col-lg-4">
                                    <label class="form-group-label">
                                      {{(balanceBeforeTransaction?.remaining_tax_balance|| '0.00' ) | currency}}
                                    </label>
                                </div>
                                <div class="field-group mb-3 col-lg-2 text-center">
                                    <label class="form-group-label">
                                      <img class="img-fluid icon-dark" src="assets/images/icons/arrow2.png" alt="" />
                                      <img class="img-fluid icon-light" src="assets/images/icons/arrow2-light.png" />
                                    </label>
                                </div>
                                <div class="field-group mb-3 col-lg-5">
                                    <label class="form-group-label balance-after">
                                      {{(balanceAfter?.tax_payment ) | currency}}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <val-errors controlName="tax_payment">
                          <ng-template valError="currencyRange" *ngIf="!takePaymentForm?.controls?.tax_payment?.errors?.invalidPaymentSign && !isIncompleteNegativeBreakdownInput('tax_payment')">{{'Sales Tax must be between'|translate}} {{manualBreakdownRangeMin | currency}} {{'and'|translate}} {{manualBreakdownRangeMax | currency}}.</ng-template>
                          <ng-template valError="invalidBalanceAfterRange"  let-error="error" *ngIf="!takePaymentForm?.controls?.tax_payment?.errors?.currencyRange && !takePaymentForm?.controls?.tax_payment?.errors?.invalidPaymentSign  && !isLoadingEffectiveDateBalances">{{error?.message|translate}}.</ng-template>
                          <ng-template valError="invalidPaymentSign" let-error="error">{{error?.message|translate}}.</ng-template>
                        </val-errors>
                    </div>
                    <!-- Item 6 -->
                    <div class="maunal-waterfall-breakdown-grid maunal-waterfall-breakdown-grid-2 align-items-center">
                      <div class="maunal-waterfall-breakdown-item">
                        <div class="row gutters-5">
                          <div class="field-group mb-3 col-lg-5">
                            <label class="form-group-label">{{"Down Payment"|translate}}</label>
                          </div>
                          <div class="field-group mb-3 col-lg-7">
                            <div class="currency-wrap">
                              <span class="currency-code">$</span>
                              <input type="text" name="down_payment" formControlName="down_payment"
                                (input)="onManualBreakdownInput('down_payment', $event)" (blur)="calculateBalance($event)" class="form-control form-control-sm"
                                placeholder="0.00" [value]="" 
                                onfocus="select()" 
                              mask="separator.2" thousandSeparator="," [allowNegativeNumbers]="true" />
                            </div>
                          </div>
                        </div>
                      </div>
                        <div class="maunal-waterfall-breakdown-item" [ngClass]="{'visibility-hidden' : isEffectiveDateChangedInEditMode}">
                            <div class="row gutters-5">
                                <div class="field-group mb-3 col-lg-4">
                                    <label class="form-group-label">
                                      {{(balanceBeforeTransaction?.remaining_down_payment_balance || '0.00' )| currency }}
                                    </label>
                                </div>
                                <div class="field-group mb-3 col-lg-2 text-center">
                                    <label class="form-group-label">
                                        <img class="img-fluid icon-dark" src="assets/images/icons/arrow2.png" alt="" />
                                        <img class="img-fluid icon-light" src="assets/images/icons/arrow2-light.png" alt=""/>
                                    </label>
                                </div>
                                <div class="field-group mb-3 col-lg-5">
                                    <label class="form-group-label balance-after">
                                      {{(balanceAfter?.down_payment ) | currency}}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <val-errors controlName="down_payment">
                          <ng-template valError="currencyRange" *ngIf="!takePaymentForm?.controls?.down_payment?.errors?.invalidPaymentSign && !isIncompleteNegativeBreakdownInput('down_payment')">{{'Down Payment must be between'|translate}} {{manualBreakdownRangeMin | currency}} {{'and'|translate}} {{manualBreakdownRangeMax | currency}}.</ng-template>
                          <ng-template valError="invalidBalanceAfterRange"  let-error="error" *ngIf="!takePaymentForm?.controls?.down_payment?.errors?.currencyRange && !takePaymentForm?.controls?.down_payment?.errors?.invalidPaymentSign  && !isLoadingEffectiveDateBalances">{{error?.message|translate}}.</ng-template>
                          <ng-template valError="invalidPaymentSign" let-error="error">{{error?.message|translate}}.</ng-template>
                        </val-errors>
                    </div>
                    <!-- Item 7 -->
                    <div class="maunal-waterfall-breakdown-grid maunal-waterfall-breakdown-grid-2 align-items-center">
                      <div class="maunal-waterfall-breakdown-item">
                        <div class="row gutters-5">
                          <div class="field-group mb-3 col-lg-5">
                            <label class="form-group-label">{{'Total'|translate}}</label>
                          </div>
                          <div class="field-group mb-3 col-lg-7">
                            <!-- text-danger -->
                            <div class="currency-wrap">
                              <span class="currency-code">$</span>
                              <input type="text" name="total_payment" formControlName="total_payment"
                                #totalFee class="form-control form-control-sm"
                                [ngClass]="{' text-danger' : isOverAmount}"  placeholder="0.00" readonly 
                                mask="separator.2" thousandSeparator="," [allowNegativeNumbers]="true"/>
                            </div>
                          </div>
                          <!-- <val-errors controlName="total_payment">
                            <ng-template valError="currencyRange">{{'Total must be between'|translate}} -{{paymentAmountLimit | currency}} {{'and'|translate}} {{paymentAmountLimit | currency}}.</ng-template>
                          </val-errors> -->
                        </div>
                      </div>
                    </div>
                    <div class="font-size-14 text-danger" *ngIf="isOverAmount">
                      {{'Breakdown total must match the payment amount.'|translate}}
                    </div>
                  </div>
                  <div *ngIf="loanTransactionDetails?.payment_info_code?.code_type!='NON-CASH-SYSTEM'">{{'Or'|translate}} <button type="button" class="btn btn-link px-0 text-underline" (click)="toggleTakeMethodType()">{{'Use Default Waterfall'|translate}}</button></div>
                </div>
                <button *ngIf="this.isManualBreakdownAllowed() && !isManualTakePayment && loanTransactionDetails?.payment_info_code?.code_type!='NON-CASH-SYSTEM'" type="button" class="btn btn-link px-0 text-underline" (click)="toggleTakeMethodType()">{{'Manual Waterfall Breakdown'|translate}}</button>
                <!-- <button *ngIf=" !isManualTakePayment && loanTransactionDetails?.payment_info_code?.code_type!='NON-CASH-SYSTEM'" type="button" class="btn btn-link px-0 text-underline" (click)="toggleTakeMethodType()">{{'Manual Waterfall Breakdown'|translate}}</button> -->
                <div class="mt-3 field-group mb-3">
                  <label>{{'Reference Note'|translate}}</label>
                  <input type="text" class="form-control form-control-sm" name="reference_note" formControlName="reference_note" value="Check #123" appTrimOnFocusout/>
                  <val-errors controlName="reference_note">
                    <ng-template valError="pattern"
                    >{{'Reference Note is not well formed'|translate}}.</ng-template>
                    <ng-template valError="maxlength">{{'Reference Note cannot be longer than 200 characters'|translate}}.</ng-template>
                    <ng-template valError="minlength" *ngIf="!takePaymentForm.get('reference_note')?.hasError('pattern')">
                      {{'Reference Note cannot be less than 4 characters'|translate}}.
                    </ng-template>
                  </val-errors>
                </div>
                <div class="mt-3 field-group mb-3" *ngIf="editMode">
                  <div class="field-group mb-3">
                    <label class="form-group-label field-required  hide-before-border">{{'Reason for Edit'|translate}}</label>

                  </div>
                  <div class="mt-3 field-group mb-3">
                    <input type="text"  class="form-control form-control-sm"
                    name="payment_edit_reason" formControlName="payment_edit_reason" [value]="" appTrimOnFocusout/>
                    <val-errors controlName="payment_edit_reason">
                      <ng-template valError="required">{{'Please Enter Reason for Edit'|translate}}.</ng-template>
                      <ng-template valError="pattern">{{'Reason for Edit is not well formed'|translate}}.</ng-template>
                      <ng-template valError="maxlength">{{'Reason for Edit cannot be longer than 100 characters'|translate}}.</ng-template>
                      <ng-template valError="minlength" *ngIf="!takePaymentForm.get('payment_edit_reason')?.hasError('pattern')">
                        {{'Reason for Edit cannot be less than 4 characters'|translate}}.
                      </ng-template>
                    </val-errors>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer pt-0 cursor-pointer justify-space-between" cdkDragHandle>
          <div class="custom-checkbox-input">
            <div class="align mb-2 paynearme-section" *ngIf="showEffectiveDateChangeWarning && !disablePastDate && !isFutureDate && !isDefaultBreakdownPrincipalLimitReached && !salesTaxNotAllowed">
              <div class="form-check d-inline-block">
                <input id="approveEffectiveDateWarningCheck" name="approveEffectiveDateWarning" type="checkbox" [(ngModel)]="isApproveWarningMessage2" [ngModelOptions]="{ standalone: true }"
                  class="form-check-input">
                <label class="form-check-label" for="approveEffectiveDateWarningCheck"></label>
              </div>
              <div class="d-inline-block ps-1 mtpx-2 font-size-14 text-yellow cursor-auto">
                {{warningMessage2 | translate}}
              </div>
            </div>
            <ng-container>
            <span class="d-block font-size-14 text-danger" *ngIf="disablePastDate && !isDefaultBreakdownPrincipalLimitReached">
              {{'Effective date cannot be prior to the import date:'|translate}} {{previousTransaction?.import_transaction_date | date: DATE_FORMAT_MMDDYYYY }}.
            </span>
            <span class="d-block font-size-14 text-danger" *ngIf="isFutureDate && !isDefaultBreakdownPrincipalLimitReached">
              {{'Effective date cannot be in the future.'|translate}}
            </span>
            <span class="d-block font-size-14 text-danger" *ngIf="isDefaultBreakdownPrincipalLimitReached && !isFutureDate && !disablePastDate
            && !salesTaxNotAllowed && !isLoadingEffectiveDateBalances">
              {{principalBalanceLimitErrorMessage}}
            </span>
            <span class="d-block font-size-14 text-danger" *ngIf="salesTaxNotAllowed && !isDefaultBreakdownPrincipalLimitReached">
              {{'You are not allowed to use this payment code as the waterfall associated with this contains a Deferred Sales Tax component.'|translate}}
            </span>
            <span class="d-block font-size-14 text-yellow" *ngIf="isLoadingEffectiveDateBalances && !disablePastDate && !isFutureDate && !salesTaxNotAllowed && !isDefaultBreakdownPrincipalLimitReached">
              <!-- {{'Please Wait! Recalculating balances for selected effective date.'|translate}} -->
            </span>
            <div class="align paynearme-section"
              *ngIf="showTotalRemainingWarning">
              <div class="form-check d-inline-block">
                <input id="approveCheck" name="same" type="checkbox" [(ngModel)]="isApprove" [ngModelOptions]="{ standalone: true }"
                  class="form-check-input">
                <label class="form-check-label" for="approveCheck"></label>
              </div>
              <div class="d-inline-block font-size-14 text-yellow cursor-auto">
                {{warningMessage}}
              </div>
            </div>
            </ng-container>
          </div>
          <div class="text-end">
            <button type="button" [disabled]="isLoadingEffectiveDateBalances||isFutureDate||disablePastDate||salesTaxNotAllowed||(isDefaultBreakdownPrincipalLimitReached)||(showTotalRemainingWarning && !isApprove)||(showEffectiveDateChangeWarning && !isApproveWarningMessage2)" class="btn btn-success-light btn-150"  (click)="onTakePaymentSubmit()">
              {{'Apply'|translate}}
            </button>
          </div>
        </div>
      </form>
</ng-container>
</div>
</div>
